import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["align", "className", "selected", "typographyClassName", "value", "variant"];
import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import PickersToolbarText from './PickersToolbarText';
var PickersToolbarButtonRoot = styled(Button)({
  padding: 0,
  minWidth: 16,
  textTransform: 'none'
});
var PickersToolbarButton = /*#__PURE__*/React.forwardRef(function PickersToolbarButton(props, ref) {
  // eslint-disable-next-line react/prop-types
  var align = props.align,
    className = props.className,
    selected = props.selected,
    typographyClassName = props.typographyClassName,
    value = props.value,
    variant = props.variant,
    other = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(PickersToolbarButtonRoot, _extends({
    "data-mui-test": "toolbar-button",
    variant: "text",
    ref: ref,
    className: className
  }, other), /*#__PURE__*/React.createElement(PickersToolbarText, {
    align: align,
    className: typographyClassName,
    variant: variant,
    value: value,
    selected: selected
  }));
});
export default PickersToolbarButton;